import { render, staticRenderFns } from "./InputIdentification.vue?vue&type=template&id=358c7056&scoped=true&"
import script from "./InputIdentification.vue?vue&type=script&lang=js&"
export * from "./InputIdentification.vue?vue&type=script&lang=js&"
import style0 from "./InputIdentification.vue?vue&type=style&index=0&id=358c7056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c7056",
  null
  
)

export default component.exports